export const olt_moltxgspon_8p = {
    meta_title: " GPON & XGSPON OLT | Niurix MOLT XGSPON 8P",
    meta_description: "Niurix MOLT XGSPON 8P supports GPON and XG(S)PON technologies for future-ready fiber access networks.",

    section1: {
        background_img: "MOLT-XGSPON8P banner",
        background_img_mobile: "MOLT-XGSPON 8P banner",
    },

    section2: {
        mainHeading: `<span>Our</span> Product (OLTs)`,
        subHeading: "Niurix MOLT-XGSPON 8P",
        mainPara: "",
        para: `<p>The Niurix MOLT XGSPON 8P OLT is an advanced, enterprise-ready fiber access platform designed to support GPON and XGPON within a compact and efficient footprint\n\nBuilt for growing properties and mid-scale deployments, it enables organizations to transition from GPON today to higher-bandwidth PON technologies tomorrow—without redesigning the network core..</p>`,
        background_img1: "Overview background",
        background_img1_mobile: "Product solt 08 backg",
    },
    section3: {
        mainHeading: `Enterprise-Grade<span>GPON</span> Access`,
        // subHeading1: "subheading1",
        para1: `<p>As bandwidth requirements increase, traditional copper and legacy LAN designs struggle to scale. The MOLT-XGS-08P XGSPON OLT enables organizations and network operators to deploy a fiber-based access architecture using GPON and XGS-PON technologies from a single, centralized platform.\n\nWith centralized control at the OLT and distributed services delivered over fiber to ONTs, the platform simplifies network operations while supporting advanced bandwidth, quality of service, and a clear upgrade path to symmetrical 10 Gbps services.</p>`,
        subHeading2: "The Twist Towards Simpler Connectivity",
        para2: `<ul><li>4 Ethernet port</li><li>1 GPON Uplink Port</li><li>... etc. ...</li></ul>`,
        background_img: "Component MOLT-XGSPON8P",
    },
    section4: {
        background_img: "Detail",
        background_img_mobile: "details MOLT-XGSPON 8P",

        title: "The Foundation for Scalable Fiber Access",
        text_content_groups: [
            {
                title: "Multi-Generation PON Support",
                para: "Supports GPON, and XGSPON on the same platform",
            },
            {
                title: "8× Combo PON Ports",
                para: "Each port configurable as GPON or XGSPON for flexible deployments.",
            },
            {
                title: "High-Capacity Core Connectivity",
                para: "2× 100GE uplink ports with OMCI-based remote management in a compact 1U chassis.",
            },
        ],
    },
    section5: [
        {
            title: "General Product Specifications of MOLT - XGSPON 8P ",
            specifications: "Specification",
            dimension: "Dimensions",
            specification: [
                {
                    title: "Combo PON Ports (GPON / XGSPON)",
                    value: "08",
                },
                {
                    title: "10GE / GE SFP + Ports",
                    value: "04",
                },
                {
                    title: "100G QSFP28 Ports",
                    value: "02",
                },

                {
                    title: "Power Supply",
                    value: "AC: 100V AC ~ 240V AC DC: -36V DC ~ -75V DC",
                },
                {
                    title: "Power Consumption",
                    value: "90 W",
                },
                {
                    title: "Switching Capacity",
                    value: "720 Gbps",
                },
            ],
            dimensions: [
                {
                    title: "Length",
                    value: "440mm",
                },
                {
                    title: "Width",
                    value: "270mm",
                },
                {
                    title: "Depth",
                    value: "44mm",
                },
                {
                    title: "Weight",
                    value: "6.5 kg",
                },
                {
                    title: "Rack Mountable",
                    value: "Yes (1U)",
                },
            ],
            para: "Click to download the full specifications",
            pdf: "Niurix MOLT XGSPON 8P",
        },
    ],
    swiper: [
        {
            img: "Spec 1",
        },
        {
            img: "Spec 2",
        },
        {
            img: "Spec 3",
        },
        {
            img: "Spec 4",
        },
    ],
    swipper: {
        img1: "Spec 1",
        img2: "Spec 2",
        img3: "Spec 3",
        img4: "Spec 4",
    },
    section6: {
        video: "Video",
    },
    section7: {
        background_img: "contact banner",
        title: "section5",
    },
};
